import { itemHasContent } from '../../utils/helpers';

const gkgFields = ['name', 'description'];
const sections = [
  'getStrategies',
  'keepStrategies',
  'growStrategies',
  'referralStrategies',
];

export default function calculateGkgProgress(rootState, minRequired = 1) {
  let filledCount = 0;
  let totalCollectionItems = 0;

  sections.forEach((section) => {
    if (rootState.getKeepGrow[section].length) {
      rootState.getKeepGrow[section].forEach((item) => {
        let foundUnfilledField = false;

        gkgFields.forEach((field) => {
          if (!itemHasContent(item, [field])) {
            foundUnfilledField = true;
          }
        });

        if (!foundUnfilledField) filledCount += 1;
      });
    }
    totalCollectionItems += rootState.getKeepGrow[section].length;
  });

  if (filledCount === 0) return 0;
  const denominator = Math.max(minRequired, totalCollectionItems);
  const sectionProgress = Math.round((filledCount / denominator) * 100);
  return sectionProgress;
}
